<template>
    <v-row v-if="program" :class="['kimsa-elevation', { 'readonly': readonly }]" :ripple="!readonly" @click="onClick"
        @mouseover="$emit('hover')" @mouseout="$emit('hover-out')">
        <v-col cols="3" class="pa-0">
            <div class="img-program" :style="{ backgroundImage: `url('${programImg}')` }" />
        </v-col>
        <v-col cols="9" class="p-relative">
            <div :class="['name-program text-truncate', { 'name-width': withMenu }]">
                {{ program.name }}
            </div>
            <div class="description-program text-lowercase">
                {{ routinesQuantity }}
                {{ $t('programs.routines') }}
            </div>
            <v-menu offset-x v-if="withMenu">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="menu-card">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item link @click="assignProgram">
                        <v-list-item-title>
                            {{ $t('programs.assign_program') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="copyProgram">
                        <v-list-item-title>
                            {{ $t('programs.copy_program') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="deleteProgram">
                        <v-list-item-title>
                            {{ $t('programs.delete_program') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="saveInFolder">
                        <v-list-item-title>
                            {{ $t('common.save_in_folder') }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>

export default {
    props: {
        program: {
            type: Object,
            default: null,
        },
        withMenu: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        programImg(vm = this) {
            return vm.program?.img || vm.imgPlaceholder
        },
        routinesQuantity(vm = this) {
            return vm.program?.assignedRoutines?.length || vm.program?.assignedRoutines || 0
        },
    },
    methods: {
        onClick() {
            const vm = this
            vm.$emit('click')
        },
        copyProgram() {
            const vm = this
            vm.$emit('copy')
        },
        deleteProgram() {
            const vm = this
            vm.$emit('delete')
        },
        saveInFolder() {
            const vm = this
            vm.$emit('folder')
        },
        assignProgram() {
            const vm = this
            vm.$emit('assign')
        },
    },
}
</script>

<style scoped>
.name-program {
    font-size: 15px;
    font-weight: bold;
}

.name-width {
    width: 85%;
}

.description-program {
    font-size: 13px;
    color: #999999;
}

.img-program {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: rgba(1, 55, 46, 0.07);
    height: 100%;
}

.readonly {
    pointer-events: none;
}

.menu-card {
    position: absolute;
    right: 12px;
    top: 4px;
}
</style>